import { Component, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';

import { Solicitante } from '../../../models/solicitante.model';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { CertificadosService } from 'src/app/services/certificados.service';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-solicitante",
    templateUrl: "./solicitante.component.html",
    styleUrls: ["./solicitante.component.css"],
    providers: [UserService, FormService, CertificadosService]
})

export class SolicitanteComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    @ViewChild('openModalVer', { static: true }) openModalVer:TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;

    public rut_sol;
    public invalidRut: Boolean;
    public solicitante: Solicitante;
    public rows = [];
    public actualRow;
    public matcher = new FormService();

    constructor(private fb: FormBuilder, private _userService: UserService, private _CertificadosService:CertificadosService,
        private rutValidator: RutValidator, private dialog: MatDialog) {

        this.rut_sol = this.fb.group({
            rut: ['', [Validators.required, this.rutValidator]]
        })


        if (!JSON.parse(localStorage.getItem("solicitantes"))) {
            localStorage.setItem("solicitantes", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("solicitantes"));
        }
        this.invalidRut = true;
        this.solicitante = {rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''};
    }

    get_solicitante(rut? ,soloVer?){
        this._CertificadosService.getSolicitante(rut).subscribe(
            response => {
                console.log(response)
                if(response.message){
                    this.solicitante.rut = rut ? rut : '';
                        this.dialog.open(this.openModal);
                } else {
                    this.solicitante.rut = response.rut ? response.rut : '';
                    this.solicitante.nombre = response.nombre ? response.nombre : '';
                    this.solicitante.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.solicitante.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.solicitante.direccion = response.direccion ? response.direccion : '';
                    this.solicitante.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.solicitante.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.solicitante.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.solicitante.comuna = response.comuna ? response.comuna : '';
                    this.solicitante.fono = response.fono ? response.fono : '';
                    this.solicitante.fax = response.fax ? response.fax : '';
                    this.solicitante.mail = response.mail ? response.mail : '';
                    this.solicitante.recordId = response.recordId ? response.recordId : '';
                    if  (soloVer){
                        this.dialog.open(this.openModalVer);
                    }
                    else{
                        this.dialog.open(this.openModal);
                    } 
                }

            },
            error => {
                console.log(error)
            }
        )
    }



    cleanData(){
        this.solicitante = {rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''};
            this.rut_sol.reset()
    }

    saveSolicitante() {
        this._CertificadosService.saveSolicitante(this.solicitante).subscribe(
            response => {
                console.log(response)
                if (response.update || response.save) {
                    $("#prop_modal").modal("hide");
                    this.actualRow = localStorage.getItem("solicitantes");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.solicitante.rut,
                        nombre: this.solicitante.nombre,
                        apellido_pat: this.solicitante.apellido_pat,
                        apellido_mat: this.solicitante.apellido_mat,
                        direccion:this.solicitante.direccion, 
                        direccion_num:this.solicitante.direccion_num, 
                        direccion_complemento:this.solicitante.direccion_complemento, 
                        direccion_completa:this.solicitante.direccion_completa, 
                        comuna:this.solicitante.comuna, 
                        fono:this.solicitante.fono,
                        fax:this.solicitante.fax,
                        mail:this.solicitante.mail,
                        recordId:this.solicitante.recordId
                    })
                    localStorage.setItem("solicitantes", JSON.stringify(this.rows));
                    this.solicitante = {rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''};
                    this.rut_sol.reset()
                    this.dialog.closeAll();

                }
            },
            error => {
                console.log(error)
            }
        )
    }
    delete_solicitante(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("solicitantes", JSON.stringify(this.rows));
            }
        }
    }
}